import { render } from "./FaqView.vue?vue&type=template&id=2aeef80c&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"

import "./FaqView.vue?vue&type=style&index=0&id=2aeef80c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aeef80c"]])

export default __exports__